import { isClientSide } from '@tytapp/environment-utils';
import type { Environment } from '../environment';

export function mobileOverrides(environment: Environment) {
    if (isClientSide() && location.hostname === 'mobile.tyt.com') {
        environment.urls.root = location.origin;
        environment.auth.domain = '.mobile.tyt.com';
        environment.cookies.storeInLocalStorage = true;
    }
}